import RouteHelpers from 'helpers/routes';
import {
  ActionWrapper,
  SectionActions,
  ContainerSection as Section
} from 'components/Reports/Reliability/View/Styled';
import { Button } from '@teachstonellc/component-library';

interface SubmitScoreSectionProps {
  isTablet: boolean;
}

function Footer({ isTablet }: SubmitScoreSectionProps) {
  const certificationsPath = RouteHelpers.getPath('certifications');

  return (
    <Section
      mt="8px"
      px="48px"
      py="24px"
      mx={{ _: '0px', lg: '32px' }}
      borderBottomRadius={isTablet ? '12px' : ''}
    >
      <SectionActions>
        <ActionWrapper />
        <ActionWrapper>
          <Button
            as="a"
            href={certificationsPath}
            fullWidth
            variant="secondary"
          >
            Certifications
          </Button>
        </ActionWrapper>
      </SectionActions>
    </Section>
  );
}

export default Footer;
